'use client'

import { pushToGtmDataLayer } from '@/lib/tracking/services/tracking.gtm'
import { trackingConsentAtom } from '@/lib/tracking/services/tracking.store'
import { useAtomValue } from 'jotai'
import { useEffect, useRef } from 'react'

/**
 * Search-specific tracking hook.
 */
export function useSearchPageTracking(
  trackingKey: string,
  searchTerm: string,
  nbResults: number,
  requestFilter: string,
) {
  const isTrackingEnabled = useAtomValue(trackingConsentAtom)
  const lastTrackingKeyRef = useRef<string | undefined>(undefined)

  useEffect(() => {
    // Only track if the key has changed
    if (!isTrackingEnabled || lastTrackingKeyRef.current === trackingKey) {
      return
    }

    if (!requestFilter) {
      pushToGtmDataLayer({
        event: 'search',
        eventCategory: `Recherche Interne -  ${nbResults > 0 ? 'Avec' : 'Sans'} Résultats`,
        eventAction: searchTerm,
        eventLabel: nbResults.toString(),
      })
    }

    // Memorize the key to avoid duplicates
    lastTrackingKeyRef.current = trackingKey
  }, [isTrackingEnabled, trackingKey, nbResults, searchTerm, requestFilter])
}
